module.exports = __webpack_public_path__ + "static/media/meiekeskkonnast.7eb15010.svg";